const initialState = {
  status: "invalid",
};

export default (
  state = initialState,
  { type, payload }
) => {
  switch (type) {
    case "COURSES_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "COURSES_SUCCESS":
      return {
        ...state,
        status: "success",
        data: payload.data,
        meta: payload.meta,
      };
    case "COURSES_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
